/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketredirectnotallowederror4Inputs */

const en_ticketredirectnotallowederror4 = /** @type {(inputs: Ticketredirectnotallowederror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This return address is not allowed.`)
};

const de_ticketredirectnotallowederror4 = /** @type {(inputs: Ticketredirectnotallowederror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Rücksprungadresse ist nicht erlaubt.`)
};

/**
* | output |
* | --- |
* | "This return address is not allowed." |
*
* @param {Ticketredirectnotallowederror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketredirectnotallowederror4 = /** @type {((inputs?: Ticketredirectnotallowederror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketredirectnotallowederror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketredirectnotallowederror4(inputs)
	return de_ticketredirectnotallowederror4(inputs)
});
export { ticketredirectnotallowederror4 as "ticketRedirectNotAllowedError" }